import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AnnuityType, FormFields } from '../../AccountForm.meta';
import { FixedAnnuitizationByYear } from './components/FixedAnnuitizationByYear/FixedAnnuitizationByYear';
import { IndexedAnnuitizationByYear } from './components/IndexedAnnuitizationByYear/IndexedAnnuitizationByYear';
import { VariableAnnuitizationByYear } from './components/VariableAnnuitizationByYear/VariableAnnuitizationByYear';

export const AnnuitizationByYear = () => {
  const { watch } = useFormContext<FormFields>();

  const annuityType = watch('bankAccount.AnnuityType');

  if (annuityType === AnnuityType.Indexed) {
    return <IndexedAnnuitizationByYear />;
  }

  if (annuityType === AnnuityType.Variable) {
    return <VariableAnnuitizationByYear />;
  }
  return <FixedAnnuitizationByYear />;
};
